import React, { useEffect, useRef, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMagnifyingGlass, faXmark } from '@fortawesome/free-solid-svg-icons'
import "./search-select.scss"
const SearchSelect = ({ uniqKey, borderColor = 'rgba(73, 175, 47, 0.21)', placeHolder = "search", options, setOptionFun, handleSubmit, isSearching }) => {
  const [searchQuery, setSearchQuery] = useState("")
  const ref = useRef([]);
  const [show, setShow] = useState(false)
  const passSearchQuery = ((event) => {
    setOptionFun(event)
  })

  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (
        show &&
        ref.current &&
        !ref.current[uniqKey].contains(e.target)
      ) {
        setShow(false);
      }
    };
    document.addEventListener("mousedown", checkIfClickedOutside);
    return () => {
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [show])

  const clearQuery = () => {
    setSearchQuery('')
    setOptionFun({ target: { value: '' }, preventDefault: () => {} })
  }

  return (
    <div className='search-select' ref={(el) => (ref.current[uniqKey] = el)}  >
      <div className='search-select__input-wrap' style={{ '--ss-accent': borderColor }}>
        <FontAwesomeIcon icon={faMagnifyingGlass} className='search-select__leading-icon' />
        <input
          className='search-select__input'
          onClick={() => setShow(true)}
          value={searchQuery || ""}
          type='text'
          placeholder={placeHolder}
          onChange={(event) => {
            setSearchQuery(event.target.value)
            passSearchQuery(event)
          }}
        />
        {searchQuery && (
          <button type='button' className='search-select__clear' onClick={clearQuery} aria-label='Clear search'>
            <FontAwesomeIcon icon={faXmark} />
          </button>
        )}
      </div>
      <div className='option-section'>
        {show && options?.length > 0 && <div className={show && options?.length > 0 ? "fixed-height" : ""}>
          {options ? options?.map((option, index) => {
            return (<div className='single-option' key={index} onClick={() => {
              setShow(!show)
              setSearchQuery('')
              handleSubmit(option)

            }}>
              <p className='text-wrap'>{option?.title || option?.name || option?.details||option?.differentialDx||option?.provisionalDx}</p>
            </div>)
          }) : ""}
        </div>}
        {/* {isSearching && <p className='px-1'>Searching...</p>} */}
        {show && options?.length === 0 && searchQuery.length > 1 ? <div className='single-option single-option--empty'>
          <p>No option found</p>
        </div> : ""}
      </div>
    </div >
  )
}

export default SearchSelect
